// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__bH0Z8","alert":"SettungsInbox_alert__1EzT4"};